import { combineEpics, ofType } from 'redux-observable'
import { of } from 'rxjs'
import { catchError, map, mergeMap, takeUntil } from 'rxjs/operators'

import { fetchImageError, fetchImageSuccess, runScanError, runScanSuccess } from './actions'
import { FETCH_IMAGE_ASYNC, RUN_VISUAL_SCAN_ASYNC } from './constants'

const startScanEpic = (action$, state$, { api, epicsErrorHandler }) =>
  action$.pipe(
    ofType(RUN_VISUAL_SCAN_ASYNC.INITIATE),
    mergeMap((action) =>
      api.visualDetection.startVisualScan(action.payload.data).pipe(
        map((response) => runScanSuccess(response)),
        catchError((error) => of(epicsErrorHandler(runScanError, error))),
        takeUntil(action$.pipe(ofType(RUN_VISUAL_SCAN_ASYNC.CANCEL)))
      )
    )
  )

const fetchImageEpic = (action$, state$, { api, epicsErrorHandler }) =>
  action$.pipe(
    ofType(FETCH_IMAGE_ASYNC.INITIATE),
    mergeMap((action) =>
      api.visualDetection.fetchImage(action.payload.data).pipe(
        map((response) => fetchImageSuccess(response)),
        catchError((error) => of(epicsErrorHandler(fetchImageError, error))),
        takeUntil(action$.pipe(ofType(FETCH_IMAGE_ASYNC.CANCEL)))
      )
    )
  )

export default combineEpics(startScanEpic, fetchImageEpic)
